import {useTranslation} from 'react-i18next';
import {useChecklistContext} from '../../../../context/checklist/ChecklistContextProvider';
import AddEditCheckList from '../../../operations/components/Modals/AddEditCheckList';
import ChecklistTable from './ChecklistTable';
import Header from './header/Header';

function ChecklistMain() {
  const {i18n} = useTranslation();
  const isHebrew = i18n.language === 'heb';
  const {
    showAddEditDialog,
    selectedChecklist,
    setSelectedChecklist,
    setShowAddEditDialog,
    copyMode,
    setCopyMode,
  } = useChecklistContext();

  return (
    <>
      <div
        className={`flex-1 min-h-0 flex flex-col ${
          isHebrew ? 'rounded-tl-[32px]' : 'rounded-tr-[32px]'
        }`}>
        <Header />

        <ChecklistTable />
      </div>

      <AddEditCheckList
        open={showAddEditDialog}
        checklistId={selectedChecklist ?? undefined}
        onClose={() => {
          setSelectedChecklist(null);
          setShowAddEditDialog(false);
          setCopyMode(false);
        }}
        useLocationContext
        copyMode={copyMode}
      />
    </>
  );
}

export default ChecklistMain;
